import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { Analytics, BackHeader, Model } from "./../../components";
import "./teachers.css";
import { MultiSelect } from "react-multi-select-component";
import { IoMdAnalytics } from "react-icons/io";
import { MdEdit, MdDelete } from "react-icons/md";
import { useAlert } from "react-alert";
const Teachers = () => {
  const alert = useAlert();
  const [modelType, setModelType] = React.useState("");
  const [classSelected, setClassSelected] = React.useState([]);
  const [subjectSelected, setSubjectSelected] = React.useState([]);
  const [addTeacherMode, setAddTeacherMode] = React.useState(false);
  const [showPageData, setShowPageData] = React.useState(1);
  const options = [
    { label: "Class 1A", value: "Class 1A" },
    { label: "Class 2B", value: "Class 2B" },
    { label: "Class 2C", value: "Class 2C" },
    { label: "Class 2D", value: "Class 2D" },
  ];
  const subject = [
    { label: "Maths", value: "Maths" },
    { label: "Science", value: "Science" },
    { label: "Librarie", value: "Librarie" },
    { label: "History", value: "History" },
  ];
  const TableData = [
    {
      teacherName: "David Anderson",
      class: "Class 1A, Class 1B, Class 2A, Class 3A	",
      subject: "Maths, Science, Librarie, History",
    },
    {
      teacherName: "David Anderson",
      class: "Class 1A, Class 1B, Class 2A, Class 3A	",
      subject: "Maths, Science, Librarie, History",
    },

    {
      teacherName: "David Anderson",
      class: "Class 1A, Class 1B, Class 2A, Class 3A	",
      subject: "Maths, Science, Librarie, History",
    },
    {
      teacherName: "David Anderson",
      class: "Class 1A, Class 1B, Class 2A, Class 3A	",
      subject: "Maths, Science, Librarie, History",
    },

    {
      teacherName: "David Anderson",
      class: "Class 1A, Class 1B, Class 2A, Class 3A	",
      subject: "Maths, Science, Librarie, History",
    },
    {
      teacherName: "David Anderson",
      class: "Class 1A, Class 1B, Class 2A, Class 3A	",
      subject: "Maths, Science, Librarie, History",
    },
    {
      teacherName: "David Anderson",
      class: "Class 1A, Class 1B, Class 2A, Class 3A	",
      subject: "Maths, Science, Librarie, History",
    },

    {
      teacherName: "David Anderson",
      class: "Class 1A, Class 1B, Class 2A, Class 3A	",
      subject: "Maths, Science, Librarie, History",
    },
    {
      teacherName: "David Anderson",
      class: "Class 1A, Class 1B, Class 2A, Class 3A	",
      subject: "Maths, Science, Librarie, History",
    },
  ];

  // add and edit teacher
  const [teacherName, setTeacherName] = React.useState("");
  const [teacherLoading, setTeacherLoading] = React.useState(false);
  const teacherNameRef = React.useRef();
  const TeacherHandler = () => {
    if (teacherName === "") {
      alert.error(<div className="alert-message">add teacher name</div>);
      teacherNameRef.current.focus();
    } else if (classSelected.length < 1) {
      alert.error(<div className="alert-message">select class</div>);
    } else if (subjectSelected.length < 1) {
      alert.error(<div className="alert-message">select subject</div>);
    } else {
      setTeacherLoading(true);
      const TeacherObject = {
        name: teacherName,
        class: classSelected,
        subject: subjectSelected,
      };
      alert.success(
        <div className="alert-message">
          you have successfully {modelType === "Add" ? "Added" : "Updated"}
        </div>
      );
      console.log(TeacherObject);
      setTimeout(() => {
        setAddTeacherMode(false);
        setTeacherLoading(false);
      }, 2000);
    }
  };
  return (
    <div>
      {showPageData === 1 && (
        <div>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={8} lg={7} md={7} sm={5} xs={12}></Grid>
              <Grid item xl={2} lg={3} md={3} sm={4} xs={6}>
                <Button
                  className="header-button"
                  variant="text"
                  onClick={() => {
                    setAddTeacherMode(true);
                    setModelType("Add");
                  }}
                >
                  <p className="page-header-button-text">+ add New Teacher</p>
                </Button>
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={3} xs={6}>
                <Button className="header-button" variant="text">
                  <p className="page-header-button-text">Save Changes</p>
                </Button>
              </Grid>
            </Grid>
          </Box>
          <h1 id="teachers-heading">Add teachers</h1>
          <div className="teachers-table-container">
            <table>
              <thead>
              <tr>
                <td className="teachers-table-id-heading">ID</td>
                <td className="teachers-table-teachers-name-heading">
                  Teachers Name
                </td>
                <td className="teachers-table-class-heading">Class</td>
                <td className="teachers-table-subject-heading">Subject</td>
                <td className="teachers-table-analytics-heading"></td>
                <td className="teachers-table-edit-heading"></td>
                <td className="teachers-table-delete-heading"></td>
              </tr>
              </thead>
              {TableData.map((tableValue, TableIndex) => {
                return (
                  <tr key={TableIndex}>
                    <td className="teachers-table-id-data">{TableIndex + 1}</td>
                    <td className="teachers-table-data">
                      {tableValue.teacherName}
                    </td>
                    <td className="teachers-table-data">{tableValue.class}</td>
                    <td className="teachers-table-data">
                      {tableValue.subject}
                    </td>
                    <td className="teachers-table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => setShowPageData(2)}
                      >
                        <IoMdAnalytics color="#663399" size={20} />
                      </Button>
                    </td>
                    <td className="teachers-table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => {
                          setAddTeacherMode(true);
                          setModelType("Edit");
                        }}
                      >
                        <MdEdit color="#663399" size={20} />
                      </Button>
                    </td>
                    <td className="teachers-table-data">
                      <Button className="table-analytics-chat-button">
                        <MdDelete color="#663399" size={20} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <br />
          <hr />
          <br />
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Teachers Name</p>
                  <input
                    type="text"
                    name="teacherName"
                    className="input"
                    placeholder="Teachers Name"
                  />
                </div>
              </Grid>
              <Grid item xl={9} lg={9} md={9} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Select Class</p>
                  <MultiSelect
                    options={options}
                    value={classSelected}
                    onChange={setClassSelected}
                    labelledBy="Select Class"
                  />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Select Subjects</p>
                  <MultiSelect
                    options={subject}
                    value={subjectSelected}
                    onChange={setSubjectSelected}
                    labelledBy="Select Class"
                  />
                </div>
              </Grid>
              <Grid item xl={9} lg={9} md={8} sm={6} xs={4}></Grid>
              <Grid item xl={3} lg={3} md={4} sm={6} xs={8}>
                <Button className="header-button" variant="text">
                  <p className="page-header-button-text">
                    Save & Generate time table
                  </p>
                </Button>
              </Grid>
            </Grid>
          </Box>
        </div>
      )}
      {showPageData === 2 && (
        <div>
          <BackHeader backHanler={() => setShowPageData(1)} />
          <Analytics
            teacherName="David Anderson"
            firstChartHeading="Total Hours"
            secondChartHeading="No. of lecture"
            thirdCharHeading="Earning"
          />
        </div>
      )}

      <Model
        modelTitle={`${modelType} teacher`}
        onClose={() => setAddTeacherMode(false)}
        open={addTeacherMode}
        buttonTitle={modelType === "Add" ? "Add" : "Update"}
        buttonHandler={TeacherHandler}
        loading={teacherLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Teachers Name</p>
                  <input
                    type="text"
                    name="teacherName"
                    className="input"
                    placeholder="Teachers Name"
                    value={teacherName}
                    ref={teacherNameRef}
                    onChange={(e) => setTeacherName(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Select Class</p>
                  <MultiSelect
                    options={options}
                    value={classSelected}
                    onChange={setClassSelected}
                    labelledBy="Select Class"
                  />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Select Subjects</p>
                  <MultiSelect
                    options={subject}
                    value={subjectSelected}
                    onChange={setSubjectSelected}
                    labelledBy="Select Class"
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </div>
  );
};
export default Teachers;
